const TOKEN_GENERATOR = (token) => {
    return `Bearer ${token}`
}
export default TOKEN_GENERATOR